import { FC } from "react";
import { IPortalPageBoxProps } from "./types";

const PortalPageBox: FC<IPortalPageBoxProps> = ({ className, overrideBackground, children }) => (
  <div
    className={`${overrideBackground ? overrideBackground : "bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark"} border border-boxBorderColor dark:border-greyDark rounded-lg p-3 lg:py-3 lg:px-4 xl:py-4 xl:px-5 ${className ?? className}`}
  >
    {children}
  </div>
);

export default PortalPageBox;
